import crypto, { BinaryLike, CipherKey } from 'crypto';

// BASE64 암호화
export const base64Encrypt = (_value: string) => {
  const key =
    process.env.NEXT_PUBLIC_CRYPT_DATA_KEY ||
    (process.env.CRYPT_DATA_KEY as string);
  const iv =
    process.env.NEXT_PUBLIC_CRYPT_DATA_IV ||
    (process.env.CRYPT_DATA_IV as string);

  // Base64 디코딩된 키와 IV를 사용
  const keyBuffer = Buffer.from(key, 'base64');
  const ivBuffer = Buffer.from(iv, 'base64');

  // 암호화
  const cipher = crypto.createCipheriv(
    'aes-256-cbc',
    keyBuffer as unknown as crypto.CipherKey,
    ivBuffer as unknown as crypto.BinaryLike
  );
  let encrypted = cipher.update(_value, 'utf8', 'base64');
  encrypted += cipher.final('base64');

  return encrypted;
};
